// Configuración pública de la app web en Firebase (no es secreta: identifica el proyecto, no da acceso).
// Los permisos los ponen firestore.rules, storage.rules y las Cloud Functions.

export const configFirebase = {
  apiKey: "AIzaSyCNk7AQH8ZrtBmPG0wIkWobkyBbKHne2Z0",
  authDomain: "porteria-a-la-puerta.firebaseapp.com",
  projectId: "porteria-a-la-puerta",
  storageBucket: "porteria-a-la-puerta.firebasestorage.app",
  messagingSenderId: "861161554294",
  appId: "1:861161554294:web:ce9c309b32bedd87aafa57",
  // Google Analytics (Consola → Configuración del proyecto → Integraciones → Google Analytics).
  measurementId: "G-2H0M2LVXBS",
};

/** Clave pública de "Certificados web push" (Consola → Configuración → Cloud Messaging). */
export const claveVapid: string =
  import.meta.env.VITE_CLAVE_VAPID ?? "BN1iymzdWlpKepTrSzjjX0cQCOuX3IAtRi8axc4Xn-i4ERxuCVtBoaoexWOSgOH867m4TxSBQkEzxpl6vaJooVQ";

/** `npm run dev:emulador` conecta la app a los emuladores locales con el proyecto de demostración. */
export const usaEmulador = import.meta.env.VITE_EMULADOR === "1";

export const REGION = "us-east1";
